import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase.ts'
import ExportRepository from '@/core/infrastructure/repositories/exports/ExportRepository.ts'
import FetchAllExportFiltersUseCase
  from '@/core/useCases/exports/FetchAllExportFiltersUseCase.ts'
import FetchExportUseCase from '@/core/useCases/exports/FetchExportUseCase.ts'

export default class ExportsModule extends ModuleBase {
  initialize(): void {
    this.initializeCore()
  }

  private initializeCore(): void {
    const exportRepository = new ExportRepository()
    this.registerRepository(ExportRepository, exportRepository)

    const fetchAllExportFiltersBySchoolYearIdUseCase = new FetchAllExportFiltersUseCase(exportRepository)
    this.registerUseCase(FetchAllExportFiltersUseCase, fetchAllExportFiltersBySchoolYearIdUseCase)

    const fetchExportUseCase = new FetchExportUseCase(exportRepository)
    this.registerUseCase(FetchExportUseCase, fetchExportUseCase)
  }
}